import { useState } from 'react';
import './App.css';
import SetupProcess from './components/SetupProcess';
import Dashboard from './components/Dashboard';

function App() {
  const [isSetupComplete, setIsSetupComplete] = useState(false);
  const [userConfig, setUserConfig] = useState(null);

  const handleSetupComplete = (config) => {
    setUserConfig(config);
    setIsSetupComplete(true);
  };

  return (
    <div className="App">
      <nav className="navbar">
        <div className="nav-brand">
          <div className="logo">D</div>
          <span className="brand-name">Delegate</span>
        </div>
      </nav>
      
      <main className="main-content">
        {!isSetupComplete ? (
          <SetupProcess onSetupComplete={handleSetupComplete} />
        ) : (
          <Dashboard userConfig={userConfig} />
        )}
      </main>
    </div>
  );
}

export default App;
